<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}">
  <div class="container">
    <div class="row justify-content-center">
      {#each blocklist(block, 'cards') as item}
      <div class="col-lg-4 mb-4">
        <!-- Start Card Blog Fullbackground - text centered -->
        <div class="card card-background card-background-no-mask move-on-hover">
          <div class="full-background" style="background-image: url({image(item, 'background', ['_', 500])})"></div>
          <div class="card-body pt-12">
            <h4 class="text-white">{text(item, 'headline')}</h4>
            <p>{@html richtext(item, 'body')}</p>
          </div>
        </div>
        <!-- End Card Blog Fullbackground - text centered -->
      </div>
      {/each}
    </div>
  </div>
</section>
